import { render, staticRenderFns } from "./Immigration.vue?vue&type=template&id=5276a1b6&scoped=true"
import script from "./Immigration.vue?vue&type=script&lang=js"
export * from "./Immigration.vue?vue&type=script&lang=js"
import style0 from "./Immigration.vue?vue&type=style&index=0&id=5276a1b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5276a1b6",
  null
  
)

export default component.exports